import {OFERTAACADEMICA} from "../Constantes";

export const obtenerFormaciones = (escuela) => {

    let index = OFERTAACADEMICA.findIndex(it => it.nombre === escuela);

    if (index >= 0) {
        let todaFormacion = OFERTAACADEMICA[index]
        return todaFormacion.items;
    } else {
        return []
    }


}